module.exports = __webpack_public_path__ + "img/xiaoman3.2ebbf82c.png";